/* Rolex Original Box Add-on for Trenzo
 * --------------------------------------
 * Product page: checkbox sirf preview kholta/band karta hai. Asal "add" tab hota hai
 * jab main "ADD TO CART" form submit hota hai — box gc-greeting-card-addon.js ke
 * submit handler se bundle ho ke watch ke saath ek hi request mein jata hai.
 *
 * Cart drawer/page: checkbox kholta hai, "Add" button se seedha cart/add.js call hota
 * hai (yahan koi product form nahi hota is liye bundling possible nahi, standalone hi theek hai).
 */
(function () {
  'use strict';

  if (window.__trenzoBoxLoaded) return;
  window.__trenzoBoxLoaded = true;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function uniq(arr) {
    return arr.filter(function (v, i) { return arr.indexOf(v) === i; });
  }
  function notify(message, type) {
    try {
      var T = window.MinimogTheme;
      if (T && T.Notification && T.Notification.show) {
        T.Notification.show({ target: document.body, method: 'appendChild', type: type || 'warning', message: message, last: 3000, sticky: false });
        return;
      }
    } catch (e) {}
    if (type === 'error' || type === 'warning') console.warn('[RolexBox]', message);
  }
  function emitCartUpdate() {
    try {
      var T = window.MinimogTheme;
      var ev = (T && T.pubSubEvents && T.pubSubEvents.cartUpdate) || 'cart-update';
      if (window.MinimogEvents && window.MinimogEvents.emit) {
        window.MinimogEvents.emit(ev, { source: 'trenzo-rolex-box' });
      }
    } catch (e) {}
  }
  function getDrawerSections() {
    var drawer = null;
    var sectionIds = [];
    try {
      drawer = document.querySelector('m-cart-drawer');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        sectionIds = uniq(drawer.getSectionsToRender().map(function (s) { return s.id; }));
      }
    } catch (err) {
      console.warn('[RolexBox] drawer sections error:', err);
      drawer = null;
      sectionIds = [];
    }
    return { drawer: drawer, sectionIds: sectionIds };
  }

  /* ===================== Checkbox: just toggle preview ===================== */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-rolex-toggle]')) return;
    var addon = t.closest('[data-rolex-addon]');
    if (!addon) return;
    var body = addon.querySelector('[data-rolex-body]');
    if (body) body.hidden = !t.checked;
  });

  /* ===================== Cart context: explicit Add button (standalone) ===================== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rolex-add]');
    if (!btn) return;
    e.preventDefault();

    var addon = btn.closest('[data-rolex-addon]');
    var variantId = addon && addon.getAttribute('data-box-variant-id');
    if (!variantId) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    var ds = getDrawerSections();
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (ds.sectionIds.length) { body.sections = ds.sectionIds; body.sections_url = window.location.pathname; }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        btn.disabled = false;

        if (res && res.status) {
          notify(res.description || res.message || 'Could not add the box.', 'warning');
          return;
        }
        if (ds.drawer && res.sections) {
          try { ds.drawer.renderContents(res); } catch (err) {}
        }
        emitCartUpdate();

        if (window.location.pathname.indexOf('/cart') === 0) {
          setTimeout(function () { window.location.reload(); }, 300);
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        notify('Network error while adding the box.', 'warning');
      });
  });

  /* ===================== Lightbox ===================== */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-rolex-zoom]');
    if (!trigger) return;
    e.preventDefault();
    var overlay = document.getElementById('trenzo-box-lightbox');
    var overlayImg = document.getElementById('trenzo-box-lightbox-img');
    if (!overlay || !overlayImg) return;
    overlayImg.src = trigger.getAttribute('href');
    overlay.classList.add('is-open');
  });
  document.addEventListener('click', function (e) {
    var overlay = document.getElementById('trenzo-box-lightbox');
    if (!overlay) return;
    if (e.target === overlay || e.target.closest('.trenzo-box-lightbox-close')) {
      overlay.classList.remove('is-open');
      var overlayImg = document.getElementById('trenzo-box-lightbox-img');
      if (overlayImg) overlayImg.src = '';
    }
  });

})();
